import React from 'react';
import defaultColors from './default';

const ThemeContext = React.createContext(defaultColors);

export default ThemeContext;
